import applicantAddressFormMeta, { IApplicantAddressFormMeta } from "@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/customerDetail/applicantAddress/formMeta/ApplicantAddressFormMeta";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";

export interface IDebitApplicationApplicantAddressFormMeta extends Omit<IApplicantAddressFormMeta, "schema"> {
    boxPo: FormInputMeta;

    schema: any;
}

let debitApplicationApplicantAddressFormMeta = {} as IDebitApplicationApplicantAddressFormMeta;

debitApplicationApplicantAddressFormMeta.boxPo = {
    name: "boxPo",
    type: "text",
    label: "Po Box",
    placeholder: "",
    validation: yup.string(),
};

debitApplicationApplicantAddressFormMeta = { ...applicantAddressFormMeta,...debitApplicationApplicantAddressFormMeta, };

debitApplicationApplicantAddressFormMeta.firstPhone.label = "1er Tél";
debitApplicationApplicantAddressFormMeta.secondPhone.label = "2ème Tél";

debitApplicationApplicantAddressFormMeta.schema = yup.object().shape(getValidationSchema(debitApplicationApplicantAddressFormMeta));

export default debitApplicationApplicantAddressFormMeta;